import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-数据管理_井身结构",
  "use": "icon-数据管理_井身结构-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-数据管理_井身结构\">\n<g>\n\t<path d=\"M15.6,9.8l-3.2-3.2V0.3h-1.1v9.4L15.6,9.8z M12.4,7.7L13.6,9h-1.2V7.7z\" />\n\t<path d=\"M4.7,9.8V0.3H3.6v6.3L0.4,9.8L4.7,9.8z M3.6,9H2.4l1.2-1.2V9z\" />\n\t<path d=\"M5.9,12.5l-3.2,3.2l4.2,0v-13H5.9V12.5z M5.8,14.9H4.6l1.2-1.2V14.9z\" />\n\t<path d=\"M10,2.7H8.9v13l4.2,0L10,12.5V2.7z M10,13.7l1.2,1.2H10V13.7z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol